import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { LocalKeyMap } from '@/local';
import ChargePopup from '../ChargePopup'
import { getUser, isUserLogin, setUser, removeUser } from '@/util'
import api from '@/api'
import styles from './rechargeEntry.module.scss'
import { Toast } from 'antd-mobile';

const navList = ['home','package','my']

const RechargeEntry = ({props}) => {
  const { t } = useTranslation();
  const { user,token } = getUser()
  const navigate = useNavigate()
  const chargePopupRef = useRef(null)

  const getMine = () => {
    console.log(user)
    api.post('/module/mine').then(res => {
      if (res?.error) return
      console.log(res)
      if ( res.id > 0 ) {
        setUser({
          token: token,
          user: res
        })
      } else {
        removeUser()
      }
    })
  }

  useEffect(()=>{
    getMine()
  }, [])

  return (
    <>
      <div className={styles.pointEntry}
        onClick={()=>{
          if (isUserLogin()) {
            // chargePopupRef.current.open()
            // fincode
            navigate(`/recharge?type=fincode`)
          } else {
            navigate(`/login`)
          }
        }}>
        <div className={styles.box}>
          <div className={styles.icon}></div>
          <div className={styles.val}>
            {user.available_score ?? 0}
            pt
          </div>
          <div className={`${styles.add}`}></div>
        </div>
      </div>
      <ChargePopup ref={chargePopupRef}></ChargePopup>
    </>

  )
}

export default RechargeEntry
